import { render, staticRenderFns } from "./ResourceHeaderProperty.vue?vue&type=template&id=692712af"
import script from "./ResourceHeaderProperty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceHeaderProperty.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports